/**
 * Client-side sort by discount percentage for the collection product grid.
 * "discount-ascending"/"discount-descending" live as extra options in the
 * same #SortBy selects, and "discount-descending" is what the section marks
 * as selected when the URL carries no sort_by. Shopify has no native sort_by
 * for discount, so the section (main-collection-product-grid.liquid) treats
 * those values as a signal to load the full collection (up to
 * discount_sort_limit, Liquid's paginate cap: 250) instead of just the
 * current page; this script only reorders whatever is currently in
 * #product-grid once that full set has landed.
 */
(function () {
  var DISCOUNT_DESC = 'discount-descending';
  var DISCOUNT_ASC = 'discount-ascending';
  var DISCOUNT_VALUES = [DISCOUNT_DESC, DISCOUNT_ASC];

  function getDiscount(item) {
    return parseFloat(item.getAttribute('data-discount-percentage')) || 0;
  }

  function sortGrid(direction) {
    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // El banner de colección se coloca en una posición fija del grid desde Liquid, así
    // que se aparta del sort y se devuelve a ese mismo índice en vez de arrastrarlo al
    // principio con el resto. En modo paginado lleva la clase anuncio-img-video; en
    // loadmore/infinite no (cambiaría su layout), así que ahí se marca con
    // data-discount-sort-fixed.
    var bannerSlots = [];
    var ordered = [];

    Array.prototype.slice.call(grid.children).forEach(function (item, index) {
      if (item.classList.contains('anuncio-img-video') || item.hasAttribute('data-discount-sort-fixed')) {
        bannerSlots.push({ index: index, node: item });
      } else {
        ordered.push(item);
      }
    });

    ordered.sort(function (a, b) {
      var diff = getDiscount(a) - getDiscount(b);
      return direction === DISCOUNT_DESC ? -diff : diff;
    });

    bannerSlots.forEach(function (slot) {
      ordered.splice(slot.index, 0, slot.node);
    });

    ordered.forEach(function (item) {
      grid.appendChild(item);
    });
  }

  function currentDiscountSort() {
    var select = document.querySelector('select[name="sort_by"]');
    if (select && DISCOUNT_VALUES.indexOf(select.value) !== -1) return select.value;

    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get('sort_by');
    return DISCOUNT_VALUES.indexOf(sortBy) !== -1 ? sortBy : null;
  }

  function observeGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return;

    // Only direct children of the container change when facets.js replaces
    // it wholesale via innerHTML; our own sortGrid() reorders nodes deeper
    // inside (#product-grid), so this never re-triggers itself.
    var observer = new MutationObserver(function () {
      var direction = currentDiscountSort();
      if (direction) sortGrid(direction);
      observeLoadingState();
    });

    observer.observe(container, { childList: true, subtree: false });
  }

  var loadingObserver = null;

  // facets.js toggles `.loading` on `.collection` while a fetch is in
  // flight. When it's a discount sort, add `.loading--discount` so the
  // overlay can show a message explaining the longer wait (loading the
  // full collection instead of a single page/batch). Re-attached after
  // every grid replacement since facets.js swaps in a brand-new
  // `.collection` node each time.
  function observeLoadingState() {
    var collection = document.querySelector('#ProductGridContainer .collection');
    if (!collection) return;

    if (loadingObserver) loadingObserver.disconnect();

    loadingObserver = new MutationObserver(function () {
      var isDiscount = Boolean(currentDiscountSort());
      collection.classList.toggle('loading--discount', collection.classList.contains('loading') && isDiscount);
    });

    loadingObserver.observe(collection, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var direction = currentDiscountSort();
    if (direction) sortGrid(direction);

    observeGrid();
    observeLoadingState();
  });
})();
